import { Rocket, Sparkles, Layers, Globe, Heart } from 'lucide-react'

function About() {
  return (
    <main className="min-h-screen gradient-bg relative overflow-hidden">
      {/* Background Effects */}
      <div className="absolute inset-0 bg-cyber-grid opacity-20 pointer-events-none"></div>

      {/* Hero Section */}
      <section className="pt-28 pb-12 px-4 relative z-10">
        <div className="max-w-5xl mx-auto">
          <div className="flex items-center gap-3 mb-6 animate-fade-in-up">
            <div className="relative p-3 bg-gradient-to-br from-cyan-500/20 to-purple-600/20 backdrop-blur-xl rounded-2xl border border-cyan-500/30">
              <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/10 to-purple-600/10 rounded-2xl animate-pulse-glow"></div>
              <Rocket className="w-6 h-6 text-cyan-400 relative z-10" />
            </div>
            <h1 className="text-3xl sm:text-4xl font-bold text-white font-display neon-text">About SiteGen</h1>
          </div>
          <p className="text-gray-300 text-lg leading-relaxed animate-fade-in-up" style={{animationDelay: '0.05s'}}>
            SiteGen helps you create stunning, conversion-focused memecoin landing pages in minutes. 
            Describe your token, and our AI crafts a unique, fully-responsive site with clean HTML, Tailwind CSS, and interactive elements.
          </p>
        </div>
      </section>

      {/* Content Sections */}
      <section className="px-4 pb-20 relative z-10">
        <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="glass-card p-6 border border-cyan-500/20 animate-fade-in-up">
            <div className="flex items-center gap-3 mb-3">
              <Sparkles className="w-5 h-5 text-purple-400" />
              <h2 className="text-xl font-semibold text-white">How It Works</h2>
            </div>
            <p className="text-gray-300 leading-relaxed">
              Enter your token details and goals. SiteGen assembles a complete page: hero, tokenomics, roadmap, social links, 
              and DEX buttons. You can iterate, preview live, and publish when ready.
            </p>
          </div>

          <div className="glass-card p-6 border border-cyan-500/20 animate-fade-in-up" style={{animationDelay: '0.05s'}}>
            <div className="flex items-center gap-3 mb-3">
              <Layers className="w-5 h-5 text-cyan-400" />
              <h2 className="text-xl font-semibold text-white">Built For Speed</h2>
            </div>
            <p className="text-gray-300 leading-relaxed">
              Designed for fast launch cycles: minimal setup, instant previews, and clean output that you can host anywhere.
            </p>
          </div>

          <div className="glass-card p-6 border border-cyan-500/20 animate-fade-in-up" style={{animationDelay: '0.1s'}}>
            <div className="flex items-center gap-3 mb-3">
              <Globe className="w-5 h-5 text-blue-400" />
              <h2 className="text-xl font-semibold text-white">What You Get</h2>
            </div>
            <ul className="text-gray-300 space-y-2">
              <li>• Fully responsive HTML with Tailwind via CDN</li>
              <li>• Contract address with copy-to-clipboard</li>
              <li>• Social links and DEX action buttons</li>
              <li>• Scrollable sections and interactive elements</li>
            </ul>
          </div>

          <div className="glass-card p-6 border border-cyan-500/20 animate-fade-in-up" style={{animationDelay: '0.15s'}}>
            <div className="flex items-center gap-3 mb-3">
              <Heart className="w-5 h-5 text-rose-400" />
              <h2 className="text-xl font-semibold text-white">Creator-Friendly</h2>
            </div>
            <p className="text-gray-300 leading-relaxed">
              No strict templates or color restrictions—each site is unique to your token’s personality. Iterate until it feels right.
            </p>
          </div>
        </div>
      </section>
    </main>
  )
}

export default About 